import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import util from "@/libs/util.js";
import { mapState, mapActions } from "vuex";
export default {
  name: "top-config",
  data: function data() {
    return {
      updateData: {},
      updateDialogVisible: false,
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        cityName: ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  methods: {
    updateDialog: function updateDialog(row) {
      this.updateData = JSON.parse(JSON.stringify(row));
      this.updateDialogVisible = true;
    },
    updateHouseTopConfig: function updateHouseTopConfig() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.updateHouseTopConfig({
                id: _this2.updateData.id,
                quarterInterval: parseInt(_this2.updateData.quarterInterval),
                quarterDuration: parseInt(_this2.updateData.quarterDuration),
                brandInterval: parseInt(_this2.updateData.brandInterval),
                brandDuration: parseInt(_this2.updateData.brandDuration),
                landlordInterval: parseInt(_this2.updateData.landlordInterval),
                landlordDuration: parseInt(_this2.updateData.landlordDuration),
                featuredDuration: parseInt(_this2.updateData.featuredDuration),
                featuredInterval: parseInt(_this2.updateData.featuredInterval),
                updateBy: util.cookies.get("uuid"),
                updateName: _this2.info.name
              });
            case 1:
              _this2.updateDialogVisible = false;
              _this2.$message.success("保存成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getHouseTopConfigList(_this3.searchForm);
            case 1:
              res = _context3.v;
              res.data.content.forEach(function (item) {
                item.updateDate = dayjs(item.updateDate).format("YYYY-MM-DD");
              });
              _this3.tableData = res.data.content;
              _this3.total = res.data.totalCount;
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    syncHouseTopCity: function syncHouseTopCity() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.syncHouseTopCity({
                adminId: util.cookies.get("uuid"),
                adminName: _this4.info.name
              });
            case 1:
              _this4.$message.success("同步成功");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};